import { RTL } from 'locales/currentLang'

export default function ErrorHandler(response) {
  switch (response?.status) {
    case 422:
      return Object.values(response.data.errors)
    case 401:
      return response.data?.data?.message
    default:
      if (RTL()) {
        return 'حدث خطأ ما اعد المحاوله في وقت لاحق'
      }
      return 'Something wrong has happened'
  }
}
